<template>
  <transition name="fade">
    <div class="message" :class="type" v-if="visible">
      <div class="content">
        <i v-if="type == 'info'" class="el-icon-message" style="font-size:14px"></i>
        <i v-if="type == 'success'" class="el-icon-circle-check" style="font-size:14px"></i>
        <i v-if="type == 'warning'" class="el-icon-warning-outline" style="font-size:14px"></i>
        <i v-if="type == 'error'" class="el-icon-circle-close" style="font-size:14px"></i>
        {{content}}
        <i v-if="hasClose" class="el-icon-close" style="color: red;font-size:14px" @click="visible=false"></i>        
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Toast",
    data() {
      return {
        content: '',  // 内容
        time: 3000, // 消失时间，默认3秒后消失
        visible: false,
        type:'info',  // info/success/warning/error，默认info
        hasClose:false, // 是否含关闭按钮，默认false
      }
    },
    mounted() {
      this.close()
    },
    methods: {
      close() {
        window.setTimeout(() =>{
          this.visible = false
        }, this.time);
      }
    }
  }
</script>
<style scoped>
.message {
  padding: 10px 20px;
  color: #fff;
  background-color: pink;
  text-align: center;
  position: fixed;
  top: 100px;
  left: 50%;
  border-radius: 6px;
  z-index: 9999;
  transform: translate(-50%, -50%);
}
/* vue动画过渡效果设置 */
.fade-enter-active,
.fade-leave-active {
  /* transition: opacity .5s; */
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  /* opacity: 0; */
}

.info {
  background-color: #edf2fc;
  color: #909399;
}
.success {
  background-color: #fdf6ec;
  color: #57c524;
}
.warning {
  background-color: #fdf6ec;
  color: #e9a23c;
}
.error {
  background-color: #fef0f0;
  color: #f7806c;
}
</style>